/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const ResourcesResponseR = t.interface({});

// optional attributes
const ResourcesResponseO = t.partial({});

export const ResourcesResponse = t.intersection(
  [ResourcesResponseR, ResourcesResponseO],
  "ResourcesResponse"
);

export type ResourcesResponse = t.TypeOf<typeof ResourcesResponse>;
